<template>
  <div class="tm-loader">
    <tm-custom-spinner :size="spinnerSize" />
    <div
      v-if="title || $slots.title"
      class="tm-loader__title"
    >
      <slot name="title">{{ title }}</slot>
    </div>
    <div
      v-if="description || $slots.description"
      class="tm-loader__description"
    >
      <slot name="description">{{ description }}</slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import TmCustomSpinner from '@/components/shared/TmCustomSpinner.vue'
import type { StylesheetSizeProp } from '@/types'

const { spinnerSize = '52px' } = defineProps<{
  spinnerSize?: StylesheetSizeProp
  title?: string
  description?: string
}>()
</script>

<style lang="scss" scoped>
.tm-loader {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  &__title {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin-top: 20px;
  }
  &__description {
    margin-top: 6px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: $neutral;
  }
}
</style>
